import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationComponent } from '../navigation/navigation.component';
import { HelpbarComponent } from '../navigation/helpbar/helpbar.component';

@Component({
  selector: 'app-primary-layout',
  template: `
    <div class="tw-grid tw-gap-8 tw-pb-32">
      <app-navigation class="tw-z-10 lt-md:tw-sticky tw-top-0 lt-md:tw-shadow" />
      <div class="tw-app-container tw-px-4">
        <router-outlet></router-outlet>
      </div>
      <app-helpbar />
    </div>
  `,
  styleUrl: './primary-layout.component.scss',
  imports: [RouterOutlet, NavigationComponent, HelpbarComponent],
})
export class PrimaryLayoutComponent {}
